import { chartReportConfigs } from '../../../utils/config/chartReportConfig';
import { useChart } from '../../../hooks/reports/useReportChart';
import { useLocation } from 'react-router-dom';
import { useReportData } from '../../../hooks/data/useReportData';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import './chartreport.css'

const ChartReport = () => {
  const location = useLocation();
  const { reportName, reportId } = location.state || {};
  const config = chartReportConfigs[reportName];
  const { data } = useReportData(reportName, 1000000);
  const chart = useChart(config, data);  
    
  return (
    <div className='reportPage'>
      <div className="pageContainer">
        <NavBar />
        <Sidebar />
        <div className="pageContent">
          <div className="scoreBoardTitle">
            <h1>{reportName}</h1>
          </div>
          <div className="reportSpace">
            <div className="chartReport">
              {chart}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChartReport